<div class="search-parameters">

    <div class="advanced-search">
        <div class="col col1">
            <div class="label">Identifiers:</div>
            <div class="label">Name:</div>
        </div>
        <div class="col col2">
            <div class="input">
                <input matInput type="text" id="ids" name="ids" [(ngModel)]="customerSearchQuery.ids">
            </div>
            <div class="input">
                <input matInput type="text" id="customerName" name="customerName"
                    [(ngModel)]="customerSearchQuery.name">
            </div>
        </div>
        <div class="col col3">
            <div class="label">Country:</div>
            <div class="label">Gravity:</div>
        </div>
        <div class="col col4">
            <div class="input">
                <input matInput type="text" id="country" name="country" [(ngModel)]="customerSearchQuery.country">
            </div>
            <div class="input">
                <mat-checkbox matTooltip="Search in Gravity - Yes/No" id="searchInGravity" name="searchInGravity"
                    [(ngModel)]="customerSearchQuery.searchInGravity">Search in
                    Gravity</mat-checkbox>
            </div>
        </div>
        <div class="col col5">
            <button class="search-button" mat-raised-button color="primary" (click)="onSearchCustomer()"
                [disabled]="!customerSearchQuery.ids && !customerSearchQuery.name && !customerSearchQuery.country">
                <mat-icon>search</mat-icon>
                Search
            </button>
        </div>

    </div>

</div>

<div class="search-results">

    <div class="empty-resultset" *ngIf="loading">
        Loading...
      </div>
    
      <div class="empty-resultset" *ngIf="!loading && customers && customers.length == 0">
        No assets have been found
      </div>
    
      <div class="empty-resultset" *ngIf="!loading && customers==null">
        Enter search criteria
      </div>


        <ng-container *ngFor="let customer of customers">
            <customer-search-result-item [customer]="customer" />
        </ng-container>

    <div #loadingTrigger class="loading-trigger">
        <p *ngIf="moreDataAvailable">Loading...</p>
    </div>
</div>